import Model from '@/class/cargo/model/utils/Model'
class FullHalf {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}
export const CODE_NAME = 'FullHalf'

export const FULL_COURSE = new FullHalf('FULL_COURSE', '全程', 'Full Course')
export const HALF_COURSE = new FullHalf('HALF_COURSE', '半程', 'Half Course')

export const TYPES = [FULL_COURSE, HALF_COURSE]

/**
		 *  return null:没找到.
		 */
export function getFullHalfByCode(code) {
  return Model.getObjByCode(code, TYPES)
}

/**
		 *  return null:没找到.
		 */
export function getFullHalfByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}
